import fmsInstances from '@/api/facility/fmsInstances'

export default {
  fmsInstances,
}
